
import { mapGetters } from 'vuex';

export default {
    name: 'AppDataWaiting',
    props: {
        loaded: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('profile', [
            'role'
        ]),
    }
}
